import React, { useEffect } from 'react';
import CustomHead from '@/components/Common/Layout/Head';
import { Layout } from '@/components/Common';
import { ReviewsCarousel } from '@/components/Common/LandingPage';
import { WEBSITE_URL } from '@/shared/constants';
import { logPageView } from '@/lib/service';
import './index.less';

export default function ReviewsPage() {
  useEffect(() => {
    logPageView({
      pageUrl: window.location.href || '',
      routeName: window.location.pathname,
      pageTitle: 'Reviews From Top Creators | Pietra',
    });
  }, []);

  const invisibleHeaderTags = (
    <div style={{ display: 'none' }}>
      <h1>Reviews from top creators on Pietra</h1>
      <h2>Read reviews from top creators using Pietra to launch their brands.</h2>
    </div>
  );

  return (
    <>
      <CustomHead
        title="Reviews From Top Creators | Pietra"
        description="Read reviews from top creators using Pietra to launch their brands."
        url={`${WEBSITE_URL}/reviews`}
      />
      <Layout>
        {invisibleHeaderTags}
        <div className="reviews-page">
          <ReviewsCarousel />
        </div>
      </Layout>
    </>
  );
}
